class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.externalTrigger = document.querySelector(this.getAttribute('data-external-trigger'));
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));
    this.externalTrigger?.addEventListener('click', this.onClickExternalTrigger.bind(this))
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event, element = null) {
    const detailsModal = element ?? event.target.closest('details');
    event.preventDefault();
    detailsModal.hasAttribute('open') ? this.close() : this.open(event, element);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event, detailsModal = null) {
    const modalElement = detailsModal ?? event.target.closest('details');
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    modalElement.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.add('no-scroll');
    this.toggleBodyClass();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.documentElement.classList.remove('no-scroll');
    this.toggleBodyClass();
  }

  onClickExternalTrigger (event) {
    event.stopPropagation();
    this.onSummaryClick.apply(this, [event, this.detailsContainer])
  }

  toggleBodyClass () {
    const bodyClass = this.summaryToggle.getAttribute('data-body-class');
    if(bodyClass) {
      document.body.classList.toggle(bodyClass, this.isOpen())
    }
  }

}

customElements.define('details-modal', DetailsModal);
